/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAbsoluteDatalayerBegincheckoutViewProps } from './absolute-datalayer-begincheckout';



const _renderInfo=(
    productName: string
): JSX.Element => {
    return (
        <div>{productName}</div>
    )
}

export default (props: IAbsoluteDatalayerBegincheckoutViewProps) => {

    const {productName} = props;


    let myTest;

    myTest = _renderInfo(productName)

    return (
        <div className='row'>
            {myTest}
        </div>
    );
};
